<template>
  <svg
    :class="direction && `rotate-arrow-icon--${direction}`"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path d="M10 0C4.48607 0 0 4.48607 0 10C0 15.5139 4.48607 20 10 20C15.5139 20 20 15.5139 20 10C20 4.48607 15.5139 0 10 0ZM10 15L6.24999 10.625H8.74997V5H11.25V10.625H13.75L10 15Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'ArrowFilled',
  props: {
    direction: {
      type: String,
      default: '',
    },
  },
};
</script>
